/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useMemo, useEffect, useRef } from "react";
import HeaderLayout from "../../layouts/admin/HeaderLayout";
import FooterLayout from "../../layouts/admin/FooterLayout";
import MaterialDataGrid from "../../components/DataTable";
import { axiosInstance } from "../../utils/commonInstance";
import useDataFetching from "../../hooks/useDataFatching";
import { Box, IconButton, Input, Modal, Typography } from "@mui/material";

import { handleExportData } from "../../components/DataTable";
import { useForm, Controller } from "react-hook-form";
import { showToast } from "../../hooks/showToast";
import Multiselect from "multiselect-react-dropdown";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
import "react-calendar/dist/Calendar.css";
import * as XLSX from "xlsx";

import { AltRoute, Close, Download } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { addSerialNumber, changeArrayKeys, createHeaderMap, extractKeysFromArray, flattenObject1, flattenObjectForReportsPage, transformData } from "../../utils/commonFunction";
import { Speaker } from "feather-icons-react";
import Echo from "laravel-echo";
import Pusher from "pusher-js";

const userId = localStorage.getItem("user_id");
const token = localStorage.getItem("accessToken");

window.Pusher = Pusher;
const echo = new Echo({
  broadcaster: "reverb",
  key: "uymf9unflbmhdwvfihe0",
  wsHost: process.env.REACT_APP_WEBSHOCKET_URL,
  wsPort: 443,
  wssPort: 443,
  forceTLS: true,
  enabledTransports: ["ws", "wss"],
  authEndpoint: `${process.env.REACT_APP_BACKEND_BASE_URL}/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  },
});

const fetchDataForPlatform = async (params, endpoint) => {
  //   return await axiosInstance.post(`web/${endpoint}`, { params });
};

const ExportReport = ({ title, dynamiColumns, endPoint, columnOrder, excludeKeys, exportColumns, keyMapping, toggleFormFillrter, filterOption, isExport = false, data }) => {
  const location = useLocation();
  const {
    state,
    columnFilters,
    setColumnFilters,
    setGlobalFilter,
    // pagination,
    // setPagination,
    manualFetchData,
  } = useDataFetching(fetchDataForPlatform, endPoint, title);
  const [calculations, setCalculations] = useState(0);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [modal, setModal] = useState({
    isOpen: false,
    headerContent: "",
    subHeaderContent: "",
    data: {},
    clicked: null,
    text: "",
  });

  const handlePreviewClick = (row) => {
    setModal((prevData) => ({
      ...prevData,
      isOpen: true,
      header: "Image Preview",
      data: row,
    }));
    // Add your edit logic here
  };

  const handleClose = () => {
    setModal((prevData) => ({
      ...prevData,
      isOpen: false,
      header: "",
      data: {},
    }));
  };

  useEffect(() => {
    // Assuming OpenNewPagination is an object with properties pageIndex and pageSize
    const calculation = pagination.pageIndex * pagination.pageSize;
    // Set test to 0 if OpenNewPagination.pageIndex is 0, otherwise use the calculation
    setCalculations(calculation);
  }, [pagination.pageIndex, pagination.pageSize]);

  const dynamicColumns = useMemo(() => {
    const columns = [];
    // Add dynamic columns
    columns.push({
      header: "Sr. No.",
      Cell: ({ row }) => {
        const number = calculations + (row?.index + 1);
        const formattedNumber = number < 10 ? `0${number}` : number;
        return <div className="sr-no">{formattedNumber}</div>;
      },
      maxSize: 15,
      minSize: 10,
    });

    dynamiColumns?.forEach((col) => {
      if (col.accessorKey === "preview") {
        // Customize the Cell renderer for the actions column
        columns.push({
          ...col,
          Cell: ({ row }) => (
            <div onClick={() => handlePreviewClick(row?.original)}>
              <a role="button" className="text-decoration-underline">
                Preview
              </a>
            </div>
          ),
        });
      } else if (col.accessorKey === "map") {
        // Customize the Cell renderer for the actions column
        columns.push({
          ...col,
          Cell: ({ row }) => (
            <div onClick={() => handlePreviewClick(row?.original)}>
              <a role="button" className="text-decoration-underline">
                Map
              </a>
            </div>
          ),
        });
      } else if (col.accessorKey === "voicenote") {
        // Customize the Cell renderer for the actions column
        columns.push({
          ...col,
          Cell: ({ row }) => {
            // Extract the relevant data from row.original
            const recordingId = row?.original?.alert_audio_url; // or whatever key holds the dynamic part

            return (
              <a href={recordingId} className="text-decoration-underline" target="_blank" rel="noopener noreferrer">
                <Speaker />
              </a>
            );
          },
        });
      } else if (col.accessorKey === "action") {
        // Customize the Cell renderer for the actions column
        columns.push({
          ...col,
          Cell: ({ row }) => {
            // Extract the relevant data from row.original
            const excelDownloadUrl = row?.original?.action; // or whatever key holds the dynamic part

            return (
              <a href={excelDownloadUrl} className={`text-decoration-underline ${row?.original?.action === null ? "export-dwnld-link" : ""}`} rel="noopener noreferrer">
                <Download />
              </a>
            );
          },
        });
      } else {
        columns.push(col);
      }
    });
    return columns;
  }, [dynamiColumns, calculations]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "max-content",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    height: "500px",
    overflow: "auto",
    "@media (max-width: 600px)": {
      width: "96%",
    },
  };

  // Define a function to remove specific items from the array
  function removeItems(array, itemsToRemove) {
    return array.filter((item) => !itemsToRemove.includes(item));
  }

  const finalArray = extractKeysFromArray(state?.data, removeItems(columnOrder, excludeKeys));
  const newArray = changeArrayKeys(finalArray, keyMapping);

  newArray &&
    newArray?.forEach((obj) => {
      delete obj.Shift;
    });

  useEffect(() => {
    setPagination({ pageIndex: 0, pageSize: 10 });
  }, [endPoint, title]);

  const [fillter, setFillter] = useState({ selectFillter: "", search: "" });
  const [selectFilter, setSelectFilter] = useState(null);
  const [roleRightsData, setRoleRightsData] = useState([]);
  const [value, onChange] = useState([]);
  //   const [value, onChange] = useState([
  //     new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  //     new Date(),
  //   ]);
  const [exportRequestedBy, setExportRequestedBy] = useState("");
  const [exportReportName, setExportReportName] = useState("");
  const [exportStatus, setExportStatus] = useState("");
  //   const StartDate = moment(value[0]).format("YYYY-MM-DD");
  //   const EndDate = moment(value[1]).format("YYYY-MM-DD");
  const StartDate = value[0] ? moment(value[0]).format("YYYY-MM-DD") : "";
  const EndDate = value[1] ? moment(value[1]).format("YYYY-MM-DD") : "";
  const [resetKey, setResetKey] = useState(0);
  const [isFiltered, setIsFiltered] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
    watch,
  } = useForm({});

  const [gridData, setGridData] = useState({
    data: [],
    rowCount: 0,
    isError: false,
    isLoading: false,
    isRefetching: false,
  });  

  const lastFetchRef = useRef("");
  const fetchData = async (force = false) => {
    const requestData = {};

    if (isFiltered) {
      if (exportRequestedBy) requestData.username = exportRequestedBy;
      if (exportReportName) requestData.export_type = exportReportName;
      if (exportStatus) requestData.status = exportStatus;
      if (value[0] && value[1]) {
        requestData.from = StartDate;
        requestData.to = EndDate;
      }
    }

    const fetchKey = JSON.stringify({
      page: pagination.pageIndex,
      size: pagination.pageSize,
      endPoint,
      exportRequestedBy,
      exportReportName,
      exportStatus,
      StartDate,
      EndDate,
      isFiltered,
    });

    if (!force && lastFetchRef.current === fetchKey) return; 
    lastFetchRef.current = fetchKey;

    try {
      setGridData((prev) => ({ ...prev, isLoading: true }));

      const url = `web/${endPoint}?limit=${pagination.pageSize}&page=${pagination.pageIndex + 1}`;

      const response = await axiosInstance.post(url, requestData);

      if (!response?.data?.error) {
        setGridData({
          data: response.data.data,
          rowCount: response.data.totalRecords || 0,
          isError: false,
          isLoading: false,
          isRefetching: false,
        });
      } else {
        showToast(response?.data?.message, "error");
        setGridData((prev) => ({ ...prev, isError: true, isLoading: false }));
      }
    } catch (error) {
      showToast("Error fetching data", "error");
      setGridData((prev) => ({ ...prev, isError: true, isLoading: false }));
    }
  };

  const handleFilterSubmit = () => {
    setIsFiltered(true);
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
  };

  const handleFilterReset = () => {
    setValue("exportRequestedBy", "");
    setValue("exportReportName", "");
    setValue("exportStatus", "");
    setExportRequestedBy("");
    setExportReportName("");
    setExportStatus("");
    onChange([]);
    setIsFiltered(false);
    setPagination({ pageIndex: 0, pageSize: 10 });
  };

  useEffect(() => {
    fetchData();
  }, [pagination, endPoint]);

  const handleAlertEvent = async (event) => {
    if (event?.web_hook === true) {
      await fetchData(true);
    }
  };

  const registerChannel = (channelName, isPrivate = false) => {
    const channel = isPrivate ? echo.private(channelName) : echo.channel(channelName);
    channel.listen(".alert.new", handleAlertEvent);
    return channelName;
  };

  const cleanupChannels = (channelNames = []) => {
    channelNames.forEach((name) => echo.leave(name));
  };

  useEffect(() => {
    const channelsToListen = [registerChannel("alerts"), registerChannel(`report-status.${userId}`, true)];

    return () => {
      cleanupChannels(channelsToListen);
    };
  }, []);

  const handleCalendarClose = () => {
    setResetKey((prev) => prev + 1);
  };

  return (
    <>
      <div className="main">
        <HeaderLayout title={title} />
        <section class="user-listmain content web">
          <>
            <div>
              <div class="mb-4 row gy-2">
                <div class="col-xxl-3 col-xl-4 col-sm-6">
                  <div className="form-group">
                    <Controller
                      name="exportRequestedBy"
                      control={control}
                      render={({ field }) => (
                        <input
                          className="form-control py-2 w-100"
                          {...field}
                          defaultValue={exportRequestedBy}
                          onChange={(e) => {
                            field.onChange(e);
                            setExportRequestedBy(e.target.value);
                          }}
                          placeholder="Requested By"
                          style={{ backgroundColor: "#f5f7fb" }}
                        />
                      )}
                    />
                  </div>
                </div>
                <div class="col-xxl-3 col-xl-4 col-sm-6">
                  <div className="form-group">
                    <Controller
                      name="exportReportName"
                      control={control}
                      render={({ field }) => (
                        <select
                          className="form-select py-2 w-100"
                          {...field}
                          defaultValue={exportReportName}
                          onChange={(e) => {
                            field.onChange(e);
                            setExportReportName(e.target.value);
                          }}
                          style={{ backgroundColor: "#f5f7fb" }}
                        >
                          <option value="" selected>
                            Select Report Name
                          </option>
                          <option value="attendance">Attendance Report</option>
                          <option value="gatelock">Gate Lock Report</option>
                          <option value="fire">Fire Report</option>
                          <option value="trespassing">Trespassing Report</option>
                          <option value="panic mode">Panic Mode Report</option>
                          <option value="salary">Salary Report</option>
                        </select>
                      )}
                    />
                  </div>
                </div>
                <div class="col-xxl-3 col-xl-4 col-sm-6">
                  <div className="form-group">
                    <Controller
                      name="exportStatus"
                      control={control}
                      render={({ field }) => (
                        <select
                          className="form-select py-2 w-100"
                          {...field}
                          defaultValue={exportStatus}
                          onChange={(e) => {
                            field.onChange(e);
                            setExportStatus(e.target.value);
                          }}
                          style={{ backgroundColor: "#f5f7fb" }}
                        >
                          <option value="" selected>
                            Select Status
                          </option>
                          <option value="requested">Requested</option>
                          <option value="failed">Failed</option>
                          <option value="done">Done</option>
                        </select>
                      )}
                    />
                  </div>
                </div>
                <div class="col-xxl-3 col-xl-4 col-sm-6">
                  <DateRangePicker
                    key={resetKey}
                    // key={location.pathname}
                    maxDate={new Date()}
                    disableClock
                    value={value}
                    onChange={onChange}
                    format={"dd/MM/y"}
                    clearIcon={null}
                    className="w-100"
                    dayPlaceholder="dd"
                    monthPlaceholder="mm"
                    yearPlaceholder="yyyy"
                    onCalendarClose={handleCalendarClose}
                  />
                </div>
                <div class="col-xxl-12 col-xl-4 col-sm-12 text-end">
                  <button onClick={handleFilterSubmit} class="btn btn-lg btn-primary px-3 h-100 me-2">
                    {" "}
                    Search
                  </button>

                  <button class="btn btn-lg btn-primary px-3 h-100" onClick={handleFilterReset} disabled={!exportRequestedBy && !exportReportName && !exportStatus && !(value[0] && value[1])}>
                    Clear
                  </button>
                </div>
              </div>
            </div>
            <MaterialDataGrid
              key={location.pathname}
              columns={dynamicColumns}
              //   data={gridData.data?.data}
              data={gridData.data}
              rowCount={gridData.rowCount}
              isError={gridData.isError}
              handleColumnFilter={setColumnFilters}
              handlePagination={setPagination}
              initialState={{
                columnFilters: columnFilters,
                isLoading: gridData.isLoading,
                pagination: pagination,
                showAlertBanner: gridData.isError,
                showProgressBars: gridData.isRefetching,
                columnOrder: columnOrder ? columnOrder : [],
              }}
            />
          </>
        </section>
        <FooterLayout />
        <style jsx>{`
          .image-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 10px;
          }
          .image-item {
            text-align: center;
          }
          .row {
            display: flex;
            justify-content: space-between;
          }
          .col {
            flex: 1 0 45%;
            margin: 10px;
            text-align: center;
          }
        `}</style>
      </div>
    </>
  );
};
export default ExportReport;
